import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, field, IntegerDecoder } from "@simonbackx/simple-encoding";
import { SimpleErrors } from "@simonbackx/simple-errors";
import { RegisterCartPriceCalculator } from "./RegisterCartPriceCalculator";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { BalanceItemCartItem, IDRegisterItem } from "./RegisterItem";
/**
 * Contains all information about a given checkout
 */
export class RegisterCart {
    constructor(items = []) {
        this.items = [];
        this.balanceItems = [];
        this.freeContribution = 0;
        this.administrationFee = 0;
        this.items = items;
    }
    clear() {
        this.items = [];
        this.balanceItems = [];
        this.freeContribution = 0;
        this.administrationFee = 0;
    }
    convert() {
        return IDRegisterCart.create({
            items: this.items.map(i => i.convert()),
            balanceItems: this.balanceItems,
            freeContribution: this.freeContribution,
            administrationFee: this.administrationFee
        });
    }
    get priceWithoutFees() {
        return this.items.reduce((total, item) => {
            return total + item.calculatedPrice;
        }, 0) + this.balanceItems.reduce((total, item) => {
            return total + item.price;
        }, 0);
    }
    get price() {
        return this.priceWithoutFees
            + this.freeContribution
            + this.administrationFee;
    }
    get count() {
        return this.items.length + this.balanceItems.length;
    }
    get isEmpty() {
        return this.count === 0;
    }
    hasItem(item) {
        const c = item.id;
        for (const i of this.items) {
            if (i.id === c) {
                return true;
            }
        }
        return false;
    }
    addItem(item) {
        this.removeItem(item);
        this.items.push(item);
    }
    removeItem(item) {
        const c = item.id;
        for (const [index, i] of this.items.entries()) {
            if (i.id === c) {
                this.items.splice(index, 1);
                return;
            }
        }
    }
    addBalanceItem(item) {
        this.removeBalanceItem(item);
        this.balanceItems.push(item);
    }
    removeBalanceItem(item) {
        const c = item.item.id;
        for (const [index, i] of this.balanceItems.entries()) {
            if (i.item.id === c) {
                this.balanceItems.splice(index, 1);
                return;
            }
        }
    }
    validate(family, groups, categories, memberBalanceItems) {
        const newItems = [];
        const errors = new SimpleErrors();
        for (const item of this.items) {
            try {
                item.validate(family, groups, categories, newItems);
                newItems.push(item);
            }
            catch (e) {
                errors.addError(e);
            }
        }
        this.items = newItems;
        const newBalanceItems = [];
        for (const item of this.balanceItems) {
            try {
                item.validate(memberBalanceItems);
                newBalanceItems.push(item);
            }
            catch (e) {
                errors.addError(e);
            }
        }
        this.balanceItems = newBalanceItems;
        errors.throwIfNotEmpty();
    }
    calculatePrices(members, groups, categories, paymentConfiguration) {
        RegisterCartPriceCalculator.calculatePrices(this.items, members, groups, categories);
        this.administrationFee = paymentConfiguration.administrationFee.calculate(this.priceWithoutFees);
    }
}
/**
 * Contains all information about a given checkout
 */
export class IDRegisterCart extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.items = [];
        this.balanceItems = [];
        this.freeContribution = 0;
        this.administrationFee = 0;
    }
    get priceWithoutFees() {
        return this.items.reduce((total, item) => {
            return total + item.calculatedPrice;
        }, 0) + this.balanceItems.reduce((total, item) => {
            return total + item.price;
        }, 0);
    }
    get price() {
        return this.priceWithoutFees
            + this.freeContribution
            + this.administrationFee;
    }
    get count() {
        return this.items.length + this.balanceItems.length;
    }
    get isEmpty() {
        return this.count === 0;
    }
    convert(organization, members) {
        const cart = new RegisterCart();
        cart.items = this.items.flatMap((item) => {
            const converted = item.convert(organization, members);
            if (converted !== null) {
                return [converted];
            }
            return [];
        });
        cart.balanceItems = this.balanceItems;
        cart.freeContribution = this.freeContribution;
        cart.administrationFee = this.administrationFee;
        return cart;
    }
    validate(family, groups, categories, memberBalanceItems) {
        const newItems = [];
        const errors = new SimpleErrors();
        for (const item of this.items) {
            try {
                item.validate(family, groups, categories, newItems);
                newItems.push(item);
            }
            catch (e) {
                errors.addError(e);
            }
        }
        this.items = newItems;
        const newBalanceItems = [];
        for (const item of this.balanceItems) {
            try {
                item.validate(memberBalanceItems);
                newBalanceItems.push(item);
            }
            catch (e) {
                errors.addError(e);
            }
        }
        this.balanceItems = newBalanceItems;
        errors.throwIfNotEmpty();
    }
    calculatePrices(members, groups, categories, paymentConfiguration, forceDate) {
        RegisterCartPriceCalculator.calculatePrices(this.items, members, groups, categories, forceDate);
        this.administrationFee = paymentConfiguration.administrationFee.calculate(this.priceWithoutFees);
    }
}
__decorate([
    field({ decoder: new ArrayDecoder(IDRegisterItem) })
], IDRegisterCart.prototype, "items", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(BalanceItemCartItem), optional: true })
], IDRegisterCart.prototype, "balanceItems", void 0);
__decorate([
    field({ decoder: IntegerDecoder, version: 91 })
], IDRegisterCart.prototype, "freeContribution", void 0);
__decorate([
    field({ decoder: IntegerDecoder, version: 208 })
], IDRegisterCart.prototype, "administrationFee", void 0);
//# sourceMappingURL=RegisterCart.js.map